import React from 'react'
import { useNavigate } from 'react-router-dom';

function Footer() {
    let navigate = useNavigate();

  const goToContact = () => {navigate('/contact');};
  const goToPrivacy = () => {navigate('/privacy');};
  const goToTerms = () => {navigate('/terms');};
  const goToPricing = () => {navigate('/pricing');};
  const goToTemplate = () => {navigate('/template');};
  const goToAbout = () => {navigate('/about');};

  const Linkedin = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={18}
      fill="none"
      {...props}
    >
      <mask
        id="a"
        width={18}
        height={18}
        x={1}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M1 0h18v18H1z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill="#000"
          fillOpacity={0.6}
          d="M17.661 0H2.328C1.596 0 1 .585 1 1.294v15.401C1 17.415 1.596 18 2.328 18H17.66c.731 0 1.328-.585 1.328-1.294V1.294C18.989.574 18.392 0 17.66 0M6.344 15.334H3.678V6.739h2.666zM5.005 5.58a1.553 1.553 0 0 1-1.552-1.541c0-.844.697-1.541 1.552-1.541s1.541.697 1.541 1.54A1.55 1.55 0 0 1 5.005 5.58m11.329 9.754h-2.666V11.16c0-.99-.023-2.273-1.384-2.273-1.362 0-1.598 1.092-1.598 2.205v4.242H8.02V6.739h2.554v1.17h.034c.36-.675 1.226-1.384 2.52-1.384 2.7 0 3.206 1.777 3.206 4.095z"
        />
      </g>
    </svg>
  );
  const FB = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      fill="none"
      {...props}
    >
      <path
        fill="#000"
        fillOpacity={0.6}
        d="M17.998 8.999a8.999 8.999 0 1 0-10.405 8.89V11.6H5.308V8.999h2.285V7.016c0-2.255 1.344-3.501 3.399-3.501.985 0 2.015.176 2.015.176v2.215h-1.135c-1.118 0-1.467.694-1.467 1.405v1.688h2.496l-.399 2.601h-2.097v6.289a9 9 0 0 0 7.593-8.89"
      />
    </svg>
  );
  const Youtube = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      fill="none"
      {...props}
    >
      <path
        fill="#000"
        fillOpacity={0.6}
        d="M9 2.07C.155 2.07 0 2.857 0 9s.155 6.93 9 6.93 9-.787 9-6.93-.155-6.93-9-6.93m2.884 7.231-4.041 1.886c-.354.164-.644-.02-.644-.41V7.224c0-.39.29-.574.644-.41L11.884 8.7c.354.166.354.436 0 .601"
      />
    </svg>
  );

  return (
    <div>
              <div className='bar mt-180 mb-80'></div>

<div className='d-flex justify-content-space-between'>
  <div className='mob-width'>
    <div>
      <img loading="lazy" width={139} src='https://imagedelivery.net/xom6JLKEu4N3wOOpuxFt7Q/d2c1fd33-babc-4b43-d890-217e019e7600/Digi' />
    </div>
    <div className='footerlogotext mt-14'>Build customized rewards & referrals programs</div>
  </div>
  <div className='gap-18 column hide'>
    <div className='footerheading'>Company</div>
    <div className='footerdesc  cp' onClick={goToAbout}>About Us</div>
  </div>
  <div className='gap-18 column hide'>
    <div className='footerheading'>Resources</div>
    <div className='footerdesc cp' onClick={goToPricing}>Pricing</div>
    <div className='footerdesc cp' onClick={goToTemplate}>Templates</div>
    <div className='footerdesc cp' onClick={goToContact}>Contact Us</div>
  </div>
  <div className='gap-18 column hide'>
    <div className='footerheading'>Legal</div>
    <div className='footerdesc cp' onClick={goToPrivacy}>Privacy Policy</div>
    <div className='footerdesc cp' onClick={goToTerms}>Terms & Conditions</div>
  </div>
</div>

<div className='d-flex gap-16 p-6'>
  <Linkedin />
  <FB />
  <Youtube />
</div>

<div className='footertext mt-18 mb-80'>{'© '+new Date().getFullYear()+' Walletly'}</div>


<div className='show'>
  <div className='d-flex justify-content-space-between'>
    <div className='gap-18 column'>
      <div className='footerheading'>Company</div>
      <div className='footerdesc cp' onClick={goToAbout}>About Us</div>
    </div>
    <div className='gap-18 column mr-100 mb-80'>
      <div className='footerheading'>Resources</div>
      <div className='footerdesc cp' onClick={goToPricing}>Pricing</div>
      <div className='footerdesc cp' onClick={goToTemplate}>Templates</div>
      <div className='footerdesc cp' onClick={goToContact}>Contact Us</div>
    </div>
  </div>
  <div className='gap-18 column mb-100'>
    <div className='footerheading'>Legal</div>
    <div className='footerdesc cp' onClick={goToPrivacy}>Privacy Policy</div>
    <div className='footerdesc cp' onClick={goToTerms}>Terms & Conditions</div>
  </div>
</div>
    </div>
  )
}

export default Footer